export const useSetBodyClass = (classList: string[]) => {
    onMounted(() => {
        document.body.classList.add(...classList);
    });
};
